module.exports = __webpack_public_path__ + "static/media/1.4a28ded4.jpg";